import React from "react";

const DeleteChartCategory = () => {
  return <div>DeleteChartCategory</div>;
};

export default DeleteChartCategory;
